<template>
  <div>      
    <!--======================================
            START CATEGORY AREA
    ======================================-->
    <section class="category-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-9">
                    <div class="section-heading">
                      <div class="section__divider"></div>
                        <h2 class="section__title">试卷中心</h2>
                    </div><!-- end section-heading -->
                </div><!-- end col-lg-9 -->
                <div class="col-lg-3">
                    <div class="button-shared h-100 d-flex align-items-center justify-content-end">
                        <router-link class="theme-btn" to="/papercenter">所有试卷<i class="el-icon-arrow-right"></i></router-link>
                    </div><!-- end button-shared-->
                </div><!-- end col-lg-3 -->
            </div><!-- end row -->
            <div class="row category-wrapper" v-if="exams.length>0">
                <div class="col-lg-4" v-for="(exam,index) in exams" :key="index" >
                    <div class="category-item">
                        <img :src="exam.picsrc?`${global.remoteIp}/uploads/${exam.picsrc}`:'/static/images/mor.jpg'" alt="">
                        <div class="category-content" >
                            <h3 class="cat__title">{{exam.title}}</h3>
                            <div><span class="cat__meta_left" ><div class="xiaozfx"></div>学{{`${exam.examinee.join(",").length>6?'':'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'}`}}科：{{exam.examinee.join(",")}}</span>
                            <span class="cat__meta_right"><div class="xiaozfx"></div>试卷类型：{{exam.papertype=='test'?'模拟考试':'竞聘考试'}}</span></div>
                            <div><span class="cat__meta_left"><div class="xiaozfx"></div>试卷总分：{{exam.totalscore}}分</span>
                            <span class="cat__meta_right"><div class="xiaozfx"></div>及格分数：{{exam.passingscore}}分</span></div>
                            <div><span class="cat__meta_left"><div class="xiaozfx"></div>考试时长：{{exam.duration}}分钟</span>
                            <span class="cat__meta_right"><div class="xiaozfx"></div>考试模式：{{getExamTimes(exam.frepeat)}}</span></div>
                            <a href="javascript:void(0)" @click="enterExam(exam)" class="cat__link" v-if="!(exam.examState=='end')">{{getExamState(exam.examState)}}</a>
                            <p  class="cat__link_end" v-if="(exam.examState=='end')">{{getExamState(exam.examState)}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <el-card  v-else  class="box-card">
                <el-empty description="暂无相关考试"></el-empty>
            </el-card>
        </div><!-- end container -->
    </section><!-- end category-area -->
    <el-dialog
        :visible.sync="faceVisible"
        :width="faceWidth"
        title="请保持脸部在取景框内"
        :show-close="false"
        center
        >
        <face-live-ex v-if="faceVisible" :visibleFlag="faceVisible" :examId ="selExams._id" ref="faceBox" @chgWidth="chgWidth($event)" @VerfiyPass="verfiyPass($event)" @VerfiyFailed = "faceVisible= false"/>
        <span slot="footer" class="dialog-footer">
            <el-button @click="faceVisible = false;" >取 消</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
import FaceLive from "../PublicComs/FaceLive.vue";
import FaceLiveEx from "../PublicComs/FaceLiveEx.vue";
export default {
  components: { FaceLive, FaceLiveEx },
  data() {
    return {
      exams: [],
      faceVisible: false,
      global,
      faceWidth: "500px",
      selExams: {},
      
    };
  },
  //
  mounted() {
    if (this.global.isPhone()) {
      this.faceWidth = "90%";
    }
    this.$axios
      .get(`/api/students/testPapers?page=1&limit=6&sort=-istop,-createdAt`)
      .then((res) => {
        if (res.data) {
          this.exams = res.data.data;
        }
      });
  },
  methods: {
    enterExam(exam) {
      if (exam.checkface&&this.$root.ischeckface) {
        this.faceVisible = true;
        this.selExams = exam;
      } else {
        this.selExams = exam;
        this.verfiyPass();
      }
    },
    verfiyPass() {
      if(this.selExams.isalone == true) {
        this.$router.push(
        this.global.isPhone()
          ? `/exam/${this.selExams._id}?_t=${Math.random()}`
          : `/examsigl/${this.selExams._id}?_t=${Math.random()}`
      );
      }else{
        this.$router.push(
        this.global.isPhone()
          ? `/exam/${this.selExams._id}?_t=${Math.random()}`
          : `/exampc/${this.selExams._id}?_t=${Math.random()}`
      );
      }
      
    },
    chgWidth(faceWidth) {
      this.faceWidth = faceWidth;
    },
    dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
    NewDate(str) {
      if (!str) {
        return 0;
      }
      let arr = str.split(" ");
      let d = arr[0].split("-");
      let t = arr[1].split(":");
      var date = new Date();
      date.setUTCFullYear(d[0], d[1] - 1, d[2]);
      date.setUTCHours(t[0], t[1], t[2], 0);
      return date;
    },
    getExamTimes(times) {
      switch (times) {
        case "0":
          return "不可补考";
        case "1":
          return "可补考一次";
        case "2":
          return "不限次数";
      }
    },
    getExamState(state) {
      switch (state) {
        case "newStart":
          return "开始考试";
        case "resit":
          return "开始补考";
        case "repeatStart":
          return "重新考试";
        case "continue":
          return "继续考试";
        case "end":
          return "考试结束";
        default:
          return "开始考试";
      }
    },
    getExamState1(state) {
      switch (state) {
        case "newStart":
          return "正在考试";
        case "resit":
          return "正在考试";
        case "repeatStart":
          return "正在考试";
        case "continue":
          return "正在考试";
        case "end":
          return "考试完成";
        default:
          return "正在考试";
      }
    },
  },
};
</script>
<style scoped>
.el-icon-arrow-right{
  color: #4282CAFF;
      font-size: 17px;
    font-weight: bold;
}
.category-item{
  margin-bottom: 15px;
}
</style>
